import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { formatCurrencyDecimal } from "../../../../app/common/util/functions";
import { View, Text } from "@react-pdf/renderer";
import compose from "../../../../app/layout/compose";
import { SettingsTicketFormatting } from "../../../../app/models/ticket";
import { useStore } from "../../../../app/stores/store";

interface Props {
  pageBreak: boolean;
  selectedSettingsTicketFormatting: SettingsTicketFormatting;
}

export default observer(function TaxItemPdfView({
  pageBreak,
  selectedSettingsTicketFormatting
}: Props) {
  const { t } = useTranslation(["common", "tickets"]);
  const { ticketSessionStore } = useStore();
  const { appliedTaxItems } = ticketSessionStore;

  return (
    <View style={{ ...compose("view pageWidth") }}
      break={pageBreak}>
      <View
        style={{ fontWeight: "bold", paddingTop: "6mm", fontSize: "4mm" }}

      >
        <Text>{t("taxes", { ns: "tickets" })}.</Text>
      </View>
      <View
        style={{ ...compose("view") }}
      >
        <View
          style={{
            ...compose(
              " view flex pageWidth borderSolidTop borderSolidRight borderSolidLeft noMargin noPadding lineHeight darkHeader textAlignCenter borderSolidBottom"
            ),
          }}
        >
          <View
            style={{
              ...compose("view width114 borderSolidRight padding1mmTop"),
            }}
          >
            <Text>
              {t("taxesPdfTable.taxName", { ns: "tickets" })}
            </Text>
          </View>
          <View
            style={{
              ...compose("view width26 padding1mmTop"),
            }}
          >
            <Text>{t("taxesPdfTable.taxRate", { ns: "tickets" })}</Text>
          </View>
        </View>
        {appliedTaxItems && appliedTaxItems.length > 0 ? (
          appliedTaxItems.map((x, index) => (
            <View
              key={`taxItem.${index}`}
              style={{
                ...compose(
                  `view flex pageWidth borderSolidRight borderSolidLeft noMargin noPadding ${appliedTaxItems.length - 1 === index && "borderSolidBottom"
                  }  ${selectedSettingsTicketFormatting.shadeAlternatingRows &&
                  index % 2 === 1 &&
                  "backgroundColorEEE"
                  }`
                ),
                flexGrow: 1,
                flexShrink: 1
              }}
              wrap={false}
            >
              <View
                style={{
                  ...compose(
                    `view width114 padding1mmTop padding5pxLeft ${selectedSettingsTicketFormatting.showBorderOnPrint &&
                    "borderSolidRight"
                    }`
                  ),
                }}
              >
                <Text>{x.taxName ?? t("taxesPdfTable.notApplicableTaxName", { ns: "tickets" })}</Text>
              </View>
              <View
                style={{
                  ...compose(
                    `view width26 textAlignRight padding1mmTop ${selectedSettingsTicketFormatting.showBorderOnPrint &&
                    "borderSolidRight"
                    }`
                  ),
                }}
              >
                <Text>{formatCurrencyDecimal(x.taxAmount, 2)}</Text>
              </View>
            </View>
          ))
        ) : (
          <View
            style={{
              ...compose(
                `view flex pageWidth borderSolidRight borderSolidLeft noMargin noPadding lineHeight borderSolidBottom`
              ),
            }}
          >
            <View
              style={{
                ...compose("view pageWidth padding1mmTop padding5pxLeft"),
              }}
            >
              <Text>{t("pdf_noItems", { ns: "common" })}</Text>
            </View>
          </View>
        )}
      </View>
    </View>
  );
});
